import React from "react";

export default function Screen(props){
    const stylingCurrentValuePostion = {
        position: "absolute",
        right: "0",
        marginRight: "20px"
    }
    const screen = {
        height:"70px",
        backgroundColor: ""+props.background,
        marginBottom: "20px",
        borderRadius: "10px",
        color:""+props.color,
        position: "relative",
        fontSize: "32px",
        display: "flex",
        alignItems: "center",
        overflow : "hidden"
      }
   
    return<div id = "screen" style = {screen}>
        <div style = {stylingCurrentValuePostion}>{props.inputValue}</div>
        </div>
}